<template>
  <div class="container"></div>
</template>

<script>
import store from "@/vuex/store.js";

export default {
  data() {
    return {
      id: ""
    };
  },
  store,
  methods: {
    router() {
      this.$router.push({
        path: "/approval_detail/" + this.id,
        params: { id: this.id }
      });
    },
    router_project() {
      this.$router.push({ path: "/project" });
    },
    router_document() {
      this.$router.push({
        path: "/document_detail/" + this.id,
        params: { id: this.id }
      });
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    if (this.$route.query.type == "project") {
      this.router_project();
    } else if (this.$route.query.type == "document") {
      this.router_document();
    } else if (this.$route.query.type == "approval") {
      this.router();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/blank.vue